import { RAISE_API_V1_URL } from "constants/endpoints";
import { patch } from "services/api";

export const saveNewPasswordRequest = async ({
  password,
  passwordConfirmation,
  resetPasswordToken
}) => {
  const response = await patch(
    `${RAISE_API_V1_URL}/passwords/update`,
    {
      password,
      password_confirmation: passwordConfirmation
    },
    {
      params: {
        reset_password_token: resetPasswordToken
      }
    }
  );
  return response.data;
};
